<template>
  <div class="container-fluid">
    <transition :css="false">
   <el-dialog title="Add Subgroup" :visible.sync="showModal" width="50%">
          <form>
          <p v-show="errorGroup" class="text-danger text-center font-weight-bold">Group Name, Subgroup Name, and Subgroup Description are required!</p>

          <arnergy-select
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
          />
          
         
         
          <div class="form-group">
          <label>Subgroup Name</label>
          <input type="text" style="height: 5rem" v-model="form.subname" class="form-control" />
          </div>
          <br />
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              >Subgroup Description</label
            >
            <textarea
              class="form-control"
              v-model="form.description"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </div>
          <div class="form-check ml-2">
            <input
              class="form-check-input"
              v-model="form.status"
              type="checkbox"
              value=""
              id="defaultCheck1"
            />
            <label class="form-check-label" for="defaultCheck1">
              {{ form.status ? "Disable" : "Enable" }}
            </label>
          </div>
          <div class="pt-4 text-right">
            <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
          <button class="btn btn-primary" @click="createSub">Create Group</button>

          </div>
          </div>
        </form>
    </el-dialog>
    </transition>
   
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">SubGroup</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <button class="btn btn-primary" @click="triggerSubgroup()">
              New Subgroup
            </button>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <SubgroupInfo />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubgroupInfo from "../user-mgt/SubgroupInfo";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import ArnergyInput from "../kitchen/ArnergyInput.vue";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue'
import { mapGetters } from 'vuex'
import 'sweetalert2/dist/sweetalert2.min.css';

import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    SubgroupInfo,
    Devices,
    transactionHistories,
    userRole,
    ArnergyInput,
    ArnergySelect,
    VueSweetalert2,
    ModalMain,
  },computed:{
     ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getGroups',
      'getDummy',
      'getDevices',
    ]),
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      loader:false,
      form: {
        subname: null,
        groupID: null,
        description: null,
        status: false,
      },
      errorGroup:false,
      groups: [{ id: null, name: null }],
      loading:false,
      formErrors: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "subname":
            if (value === "null" || value === "") {
              formErrors[field] = "Group Name cannot be empty.";
            }
            break;
          case "description":
            if (value === "null" || value === "") {
              formErrors[field] = "Group Description cannot be empty.";
            }
            break;

          default:
            break;
        }
      }
      return formErrors;
    },
    createSub(e) {
      e.preventDefault();
          const data = {
        groupid: this.form.groupID,
        subgroupname: this.form.subname,
        subgroupdesc: this.form.description,
        status: this.form.status,
      };
      console.log(data);
      const HTTP = this.$httpUtils.instance;
      if(data.groupid && data.subgroupname && data.subgroupdesc){
        this.loader = true;
      HTTP.post(
        "/customerSubGroups",
        data
      )
        .then((res) => {
            if(res.data){
               this.showModal = false
               this.showAlert()
               this.loader = false;
               this.groupID = null;
               this.form.subname= null;
               this.form.description  = null;
               this.form.status = false;
               this.fetchSubgroups()
             }
        })
        .catch((err) => {
          console.log(err);
        });
        return;
      }else{
        this.errorGroup = true;
        setTimeout(() => this.errorGroup = false, 1500);

        return;
      }

    },

    closeModal(){
      this.showModal = false;
      this.groupID = "";
               this.form.subname= "";
               this.form.description  = "";
               this.form.status = false;
      
    },
     showAlert() {
      // Use sweetalert2
      this.$swal({title: 'Success', imageWidth: '40px', text: 'SubGroup Created Successfully', icon:'success', width: '550px'});
    },
    
async triggerSubgroup(){
  console.log({getGroups: this.getGroups});
  let res= this.getGroups.map(v=>({
            id: v.id,
            name: v.groupname,
          }));
  if (res) {
    
    this.showModal = true;
  }
},
    async fetchGroups(e) {
      if(e){
         e.preventDefault()
      }
     
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.get("/customerGroups");

      // parse for "arnergy-select" use
      return res.data
        .map((item) => {
          return {
            id: item.id,
            name: item.groupname,
          };
        })
        .sort((a, b) => {
          return a.name > b.name ? 1 : -1;
        });
    },
          fetchSubgroups() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/customerSubGroups/getCustomerSubgroups
`;
       HTTP.post(url)
        .then((response) => {
          const usersList = response.data;
          this.$store.commit("saveSubgroups", usersList.map((data) => ({
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            subgroupdesc: data.subgroupdesc,
            status: data.status == 0 ? "Disabled" : "Enabled",
            id: data.id
          })));
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  async mounted() {
    this.groups = await this.fetchGroups();
    
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/Subgroup.vue